<template>
  <a-layout-content style="margin: 16px">
    <div :style="{ padding: '5px', background: '#fff', minHeight: '360px' }">
      <a-button
        type="primary"
        :style="{ margin: '0 0 10px 0' }"
        @click="topage('/home/storeManagement/newStore')"
      >
        新增门店
      </a-button>
      <a-modal
        v-model="visible"
        title="确定是否重置门店密码"
        @ok="handleOk(operate)"
        :maskStyle="{ opacity: 0.1 }"
        cancelText="取消"
        okText="确定"
      >
        <span>重置门店密码</span>
        <a-input placeholder="重置门店密码" v-model="resetPassword"/>
      </a-modal>
      <a-modal
        v-model="ifImg"
        title="门店二维码"
        @ok="handleOk2(operate)"
        cancelText="取消"
        okText="确定"
      >
        <div>
          <el-button @click="downloadCodeImg()">点击下载二维码</el-button>
        </div>
        <img
          :src="img"
          style="width: 200px; height: 200px; margin-left: 100px"
          alt=""
        />
      </a-modal>

      <a-modal
        v-model="ifImgs"
        title="小程序码"
        @ok="handleOk3(operate)"
        cancelText="取消"
        okText="确定"
      >
        <div>
          <el-button @click="downloadCodeImgs()">点击下载小程序码</el-button>
        </div>
        <img
          :src="imgs"
          style="width: 200px; height: 200px; margin-left: 100px"
          alt=""
        />
      </a-modal>

      <a-modal
        v-model="ifExchangeType"
        title="兑换类型"
        @ok="updateExchangeType(operate)"
        okText="确定"
        cancelText="取消"
      >
        <a-radio-group v-model="exchangeType">
          <a-radio :value="1">彩票</a-radio>
          <a-radio :value="2">积分</a-radio>
        </a-radio-group>
      </a-modal>

      <a-table
        :columns="columns"
        :row-key="(item) => item.objId"
        :data-source="data"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :scroll="{ y: 500, x: 2000 }"
        column-drag
      >
        <template slot="dutyCardFront" slot-scope="dutyCardFront">
          <img :src="dutyCardFront" alt=""/>
        </template>
        <template slot="dutyCardReverse" slot-scope="dutyCardReverse">
          <img :src="dutyCardReverse" alt=""/>
        </template>
        <a-avatar slot="avatar" icon="user"/>
        <a-switch
          slot="memberStatus"
          slot-scope="text, memberStatus"
          checked-children="正常"
          :checked="memberStatus.settledStatus === 1401 ? true : false"
          @change="onChange(memberStatus)"
        />
        <a-switch
          slot="defaultFlag"
          slot-scope="text, defaultFlag"
          checked-children="是"
          un-checked-children="否"
          v-model="defaultFlag.defaultFlag"
          @change="onChangeDefaultFlag(defaultFlag)"
        />
        <template slot="operate" slot-scope="text, operate">
          <a
            href=""
            v-on:click.prevent="
              topage(`/home/storeManagement/edit?uid=${operate.uid}`)
            "
          >编辑</a
          >
          <a href="javascript:;" v-on:click.prevent="showModal(operate)">重置密码</a>
          <a href="javascript:;" v-on:click.prevent="showImg(operate)"
          >门店二维码</a
          >
          <a href="javascript:;" v-on:click.prevent="showImgs(operate)">
            小程序码
          </a>

          <a
            href="javascript:;"
            v-on:click.prevent="
              topage(`/home/iconControl?shopId=${operate.shopId}`)
            "
          >功能控制</a
          >
          <a href="javascript:;" v-on:click.prevent="showExchangeType(operate)">
            兑换类型
          </a>
          <a @click="delData(operate)">删除</a>
        </template>
      </a-table>
    </div>
  </a-layout-content>
</template>
<script>
  import {getstoresData, getImg, getImgs, editExchangeType,editSettledStatus,storesList,editDefaultFlag} from "@/api/homeApi.js";
  import md5 from 'js-md5';
  import {
    queryStoresDataSeach,
    delList,
    resetpswList,
  } from "@/api/hometwoApi.js";
  import {message} from "ant-design-vue";

  const columns = [
    {
      title: "编号",
      dataIndex: "objId",
      sorter: true,
      width: "5%",
      scopedSlots: {customRender: "objId"},
    },

    {
      title: "门店ID",
      dataIndex: "shopNo",
      width: "5%",
    },

    {
      title: "门店名称",
      dataIndex: "shopName",
    },
    {
      title: "门店分类",
      dataIndex: "categoryName",
      // width: "10%",
      scopedSlots: {customRender: "categoryName"},
    },
    {
      title: "负责人姓名",
      dataIndex: "dutyName",
    },
    {
      title: "负责人电话",
      dataIndex: "dutyPhone",
    },
    {
      title: "门店状态",
      dataIndex: "settledStatus",
      sorter: true,
      scopedSlots: {customRender: "memberStatus"},
    },
    {
      title: "默认门店",
      dataIndex: "defaultFlag",
      scopedSlots: {customRender: "defaultFlag"},
    },
    {
      title: "负责人身份证正面",
      dataIndex: "dutyCardFront",
      scopedSlots: {customRender: "dutyCardFront"},
    },
    {
      title: "负责人身份证反面",
      dataIndex: "dutyCardReverse",
      scopedSlots: {customRender: "dutyCardReverse"},
    },
    {
      title: "门店地址",
      dataIndex: "address",
      sorter: true,
      // width: "25%",
    },

    {
      title: "操作",
      sorter: true,
      scopedSlots: {customRender: "operate"},
      fixed: "right",
      width: 240,
      resizable: true,
      drag: false,
    },
  ];

  export default {
    data() {
      return {
        resetPassword: "",
        data: [],
        loading: false,
        columns,
        img: "",
        imgs: "",
        exchangeType: null,
        visible: false,
        ifImg: false,
        ifImgs: false,
        ifExchangeType: false,
        item: null,
        pagination: {
          current: 1,
          total: 0,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "40", "80", "100"],
          showTotal: (total) => `共 ${total} 条`,
          pageSize: 10,
        },
        uid: '',
      };
    },
    props: ["formInline"],
    mounted() {
      // this.fetch();

      console.log(this.formInline.merchantsId)
      this.getData();
    },
    methods: {
      // 下载图片
      downloadCodeImg() {
        console.log("下载图片");
        var a = document.createElement("a");
        a.download = name || "pic";
        // 设置图片地址
        a.href = this.img;
        a.click();
      },
      downloadCodeImgs() {
        console.log("下载图片");
        var a = document.createElement("a");
        a.download = name || "pic";
        // 设置图片地址
        a.href = this.imgs;
        a.click();
      },

      topage(routerpath, operate) {
        console.log(operate, "asdadasdasihcasnckxankcxzn");
        this.$router.push(routerpath);
      },
      handleTableChange(pagination, filters, sorter) {
        console.log(pagination);
        this.pagination.current = pagination.current; //重置当前页
        this.loading = true;
        getstoresData(10, this.pagination.current).then((res) => {
          this.data = res.data;
          this.loading = false;
        });
      },
      onChange(checked) {
        console.log(`a-switch to ${checked}`);
        editSettledStatus(checked.objId).then(res => {
          message.success(res.info);
          this.getData();
        })
      },
      onChangeDefaultFlag(defaultFlag) {
        editDefaultFlag(
          {
            id: defaultFlag.objId,
            shopId: defaultFlag.shopId,
            defaultFlag: defaultFlag.defaultFlag,
            merchantsId: defaultFlag.merchantsId
          }
        ).then(res => {
          message.success(res.info);
          this.getData();
        });
      },
      //
      showModal(e) {
        console.log(e, 'e');
        this.uid = e.uid
        this.visible = true;
        // console.log(this.formInline);
      },
      showImg(row) {
        console.log(row.shopId);
        this.ifImg = true;
        getImg(row.shopId).then((res) => {
          this.img = res.data;
          // this.imgUrl = res.data
          console.log(res);
        });
      },
      showImgs(row) {
        console.log(row.shopId);
        this.ifImgs = true;
        getImgs(row.shopId).then((res) => {
          this.imgs = res.data;
          // this.imgUrl = res.data
          console.log(res);
        });
      },
      showExchangeType(row) {
        this.ifExchangeType = true;
        this.exchangeType = row.exchangeType;
        console.log(this.exchangeType)
        this.item = row.objId;
      },
      updateExchangeType() {
        editExchangeType(
          {
            id:this.item,
            exchangeType: this.exchangeType
          }
        ).then(res => {
          message.success(res.info);
          this.getData();
        });
        this.ifExchangeType = false;
      },
      handleOk(e) {
        console.log('e', e);
        let resetPassword
        resetPassword = md5(this.resetPassword)
        console.log('resetPassword', resetPassword);

        resetpswList(this.uid, resetPassword).then((res) => {
          this.visible = false;
          message.success(res.info);
        });
      },
      handleOk2(e) {
        this.ifImg = false;
      },
      handleOk3(e) {
        this.ifImgs = false;
      },
      handleSubmit() {
      },
      // 获取门店列表
      getData() {
        getstoresData(this.pagination.pageSize, this.pagination.current, this.formInline.merchantsId).then((res) => {
          this.data = res.data;
          this.pagination.total = res.count;
          this.loading = false;
        });
      },
      // 删除门店列表
      delData(row) {
        this.loading = true;
        delList(row.uid, row.shopId).then((res) => {
          this.loading = false;
          this.getData();
          message.success("删除成功");
        });
      },
      // 查询
      query() {
        this.loading = true;
        queryStoresDataSeach(
          10,
          1,
          this.formInline.categoryId,
          this.formInline.shopName,
          this.formInline.dutyPhone,
          this.formInline.merchantsId
        ).then((res) => {
          console.log(1111);
          this.pagination.total = res.count;
          this.data = res.data;
          this.loading = false;
        });
      },
    },
  };
</script>
<style scoped>
  img {
    width: 110px;
    height: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/views/right/merchants/storeManagementContent.vue